import React, { useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import { EditorState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Form } from "reactstrap";

const CommentEditor = ({ onCommentSubmit }) => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  
  const handleEditorChange = (state) => {
    setEditorState(state);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically convert editorState to HTML or raw content
    // and pass it to the parent component or directly submit to API
    if (onCommentSubmit) {
      onCommentSubmit(editorState);
    }
    // Reset editor after submission
    setEditorState(EditorState.createEmpty());
  };

  return (
    <div className="comment-editor-container">
      <Form onSubmit={handleSubmit}>
        <Editor
          editorState={editorState}
          toolbarClassName="toolbarClassName"
          wrapperClassName="wrapperClassName"
          editorClassName="editorClassName"
          onEditorStateChange={handleEditorChange}
          placeholder="Add Comment Here..."
          toolbar={{
            options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'history'],
            inline: { inDropdown: false },
            list: { inDropdown: true },
            textAlign: { inDropdown: true },
            link: { inDropdown: true },
            history: { inDropdown: false },
          }}
        />
        {/* <div className="mt-3">
          <Button color="primary" type="submit">
            Submit Comment
          </Button>
        </div> */}
      </Form>
    </div>
  );
};

export default CommentEditor;